// extracted by mini-css-extract-plugin
export default {"SideDrawer":"Sidedrawer_SideDrawer__Iij31","Open":"Sidedrawer_Open__UgEOU","Close":"Sidedrawer_Close__IcfVQ"};